// extracted by mini-css-extract-plugin
export var textInput = "_io-0";